// extracted by mini-css-extract-plugin
export default {"presetActionList":"PresetsMenu-module__presetActionList--tk2zb"};